export const generateRandomId = (): string => {
    const array = new Uint32Array(5);

    return window.crypto.getRandomValues(array).join("-");
};
